module.exports = __webpack_public_path__ + "media/images/svg/mountain-65e17ef3841470bf583973dc492691a8.svg";